export enum ServiceType {
  INTENT = 'intent',
  VISITOR_INTEL = 'visitorintel',
  ICP = 'icp',
  JOB_CHANGE = 'jobchange',
  GROWTH = 'growth',
}
